module.exports = __webpack_public_path__ + "img/angry.412ef2bb.png";